import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { makeStyles, Box } from '@applyboard/ui-components';
var useStyles = makeStyles({
  bar: {
    width: '100%',
    height: '8px',
    background: function background(props) {
      return "".concat(props.color);
    }
  }
});
var Bar = function Bar(props) {
  var color = props.color;
  var classes = useStyles({
    color: color
  });
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.bar
  });
};
export default Bar;